var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lang.id == _vm.post.lang_id
    ? _c(
        "div",
        { staticClass: "post", class: _vm.primaryPostClass },
        [
          _c(
            "b-modal",
            {
              attrs: {
                type: "warn",
                title: "Confirm Split: " + _vm.networkName,
                "ok-title": "Yes"
              },
              on: {
                ok: function($event) {
                  return _vm.splitSocialNetwork()
                }
              },
              model: {
                value: _vm.showNetworkSplit,
                callback: function($$v) {
                  _vm.showNetworkSplit = $$v
                },
                expression: "showNetworkSplit"
              }
            },
            [
              _c("p", [
                _vm._v(
                  "Do you want to split " +
                    _vm._s(_vm.networkName) +
                    " into its own post?"
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                type: "warn",
                title: "Confirm Return: " + _vm.networkName,
                "ok-title": "Yes"
              },
              on: {
                ok: function($event) {
                  return _vm.returnSocialNetwork()
                }
              },
              model: {
                value: _vm.showNetworkReturn,
                callback: function($$v) {
                  _vm.showNetworkReturn = $$v
                },
                expression: "showNetworkReturn"
              }
            },
            [
              _c("p", [
                _vm._v(
                  "Do you want to merge " +
                    _vm._s(_vm.networkName) +
                    " with the primary post?"
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("NOTE:")]),
                _vm._v(
                  " All content and comments specific to this post will be lost."
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: { title: "Network could not be split.", "ok-only": "" },
              model: {
                value: _vm.showNetworkSplitErr,
                callback: function($$v) {
                  _vm.showNetworkSplitErr = $$v
                },
                expression: "showNetworkSplitErr"
              }
            },
            [
              _c("p", [
                _vm._v(
                  "Primary post must have more than one social network to split."
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "language-heading-wrapper" }, [
            _c("h3", { staticClass: "language-heading" }, [
              _vm._v(_vm._s(_vm.lang.lang_name))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "platforms" },
              _vm._l(_vm.post.social_networks, function(network) {
                return _c("div", { staticClass: "platform" }, [
                  _c("h4", { staticClass: "platform-heading" }, [
                    _c(
                      "span",
                      {
                        staticClass: "network-button",
                        attrs: { "data-network-id": network },
                        on: { click: _vm.networkButtonClick }
                      },
                      [
                        _c("i", {
                          class:
                            "fab fa-" +
                            _vm.getSocialNetworkClassFromId(network) +
                            " platform-indicator",
                          attrs: {
                            title: _vm.getSocialNetworkNameFromId(network)
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "remaining-words",
                      class: _vm.getRemainingWordClass(network)
                    },
                    [_vm._v(_vm._s(_vm.getRemainingWordCount(network)))]
                  )
                ])
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "post-editor-fields-wrapper" },
            [
              _c("fieldset", [
                _c(
                  "label",
                  {
                    staticClass: "field-label-with-content-icon",
                    attrs: { for: "caption-" + _vm.post.id }
                  },
                  [
                    _vm._v("Post Copy "),
                    _c("i", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true }
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.hasContent,
                          expression: "!hasContent"
                        }
                      ],
                      staticClass:
                        "fas fa-exclamation-circle missing-content-icon",
                      attrs: { title: "No Post Copy or Share/Retweet" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "caption-wrap" },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.caption,
                          expression: "caption"
                        }
                      ],
                      staticClass: "post-caption",
                      class: { "min-height-set": _vm.caption },
                      attrs: { id: "post-caption-" + _vm.post.id },
                      domProps: { value: _vm.caption },
                      on: {
                        blur: _vm.postCaptionUpdated,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.caption = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("emoji-picker", {
                      staticClass: "emoji-picker-outer",
                      attrs: { search: _vm.emojiSearch },
                      on: { emoji: _vm.insertEmoji },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "emoji-invoker",
                            fn: function(ref) {
                              var clickEvent = ref.events.click
                              return _c(
                                "button",
                                {
                                  staticClass: "emoji-invoker",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return clickEvent.apply(null, arguments)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "far fa-smile" })]
                              )
                            }
                          },
                          {
                            key: "emoji-picker",
                            fn: function(ref) {
                              var emojis = ref.emojis
                              var insert = ref.insert
                              var display = ref.display
                              return _c(
                                "div",
                                { staticClass: "emoji-picker" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "emoji-search-wrap" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.emojiSearch,
                                            expression: "emojiSearch"
                                          }
                                        ],
                                        attrs: {
                                          type: "text",
                                          placeholder: "Search Emoji"
                                        },
                                        domProps: { value: _vm.emojiSearch },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.emojiSearch =
                                              $event.target.value
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "emoji-list-wrap" },
                                    _vm._l(emojis, function(
                                      emojiGroup,
                                      category
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: category,
                                          staticClass: "emoji-category"
                                        },
                                        [
                                          _c("h5", [_vm._v(_vm._s(category))]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "emoji-category-content"
                                            },
                                            _vm._l(emojiGroup, function(
                                              emoji,
                                              emojiName
                                            ) {
                                              return _c(
                                                "span",
                                                {
                                                  key: emojiName,
                                                  attrs: { title: emojiName },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.insertEmoji(
                                                        emoji
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(emoji))]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            }
                          }
                        ],
                        null,
                        false,
                        1448733771
                      )
                    }),
                    _vm._v(" "),
                    _vm.getSystemSetting("url_shortener_service") &&
                    _vm.post.caption &&
                    _vm.post.caption != ""
                      ? _c(
                          "fieldset",
                          { attrs: { id: "fs-url-" + _vm.post.id } },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-theme",
                                attrs: {
                                  type: "button",
                                  id: "btn-shorten-" + _vm.post.id
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.shortenURL(_vm.post.id)
                                  }
                                }
                              },
                              [_vm._v("Shorten URL")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-theme",
                                attrs: {
                                  type: "button",
                                  id: "btn-lengthen-" + _vm.post.id
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.lengthenURL(_vm.post.id)
                                  }
                                }
                              },
                              [_vm._v("Long URL")]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("SocialPostImageSlider", {
                attrs: {
                  socialPost: _vm.post,
                  location: "post-editor",
                  isEditor: true,
                  namespace: _vm.namespace
                }
              }),
              _vm._v(" "),
              _c(
                "fieldset",
                { class: _vm.getFileClass },
                [
                  _c("VueFilePond", {
                    ref: "resourcePond",
                    attrs: {
                      name: "file",
                      "label-idle": _vm.getIdleLabel,
                      "allow-multiple": true,
                      dropOnElement: true,
                      dropOnPage: false,
                      allowRevert: false,
                      files: _vm.filepond,
                      credits: "false"
                    },
                    on: { init: _vm.handleFilePondInit }
                  }),
                  _vm._v(" "),
                  _c(
                    "draggable",
                    {
                      staticClass: "post-image-group",
                      attrs: {
                        disabled: _vm.imageDraggingDisabled,
                        options: { forceFallback: true },
                        "ghost-class": "ghost"
                      },
                      on: {
                        change: _vm.imageOrderChanged,
                        start: _vm.dragStart,
                        update: _vm.dragUpdate,
                        end: _vm.dragEnd
                      },
                      model: {
                        value: _vm.post.files,
                        callback: function($$v) {
                          _vm.$set(_vm.post, "files", $$v)
                        },
                        expression: "post.files"
                      }
                    },
                    _vm._l(_vm.post.files, function(image) {
                      return _c("SocialPostImageDraggable", {
                        key: "image-draggable-" + image.id,
                        attrs: {
                          image: image,
                          dragging: _vm.dragging,
                          disabled: _vm.imageDraggingDisabled,
                          namespace: _vm.namespace
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "share-url-group" },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { disabled: _vm.showShareUrlDisabled },
                      on: { change: _vm.showShareUrlUpdated },
                      model: {
                        value: _vm.showShareUrl,
                        callback: function($$v) {
                          _vm.showShareUrl = $$v
                        },
                        expression: "showShareUrl"
                      }
                    },
                    [_vm._v("\n        Share/Retweet URL\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      model: {
                        value: _vm.showShareUrl,
                        callback: function($$v) {
                          _vm.showShareUrl = $$v
                        },
                        expression: "showShareUrl"
                      }
                    },
                    _vm._l(_vm.post.share_urls, function(shareUrl) {
                      return _c("SocialPostShareUrl", {
                        key:
                          "share-url-" +
                          _vm.post.id +
                          "-network-" +
                          shareUrl.id,
                        attrs: {
                          post: _vm.post,
                          shareUrl: shareUrl,
                          network: _vm.getSocialNetworkFromId(shareUrl.id)
                        },
                        on: { updated: _vm.socialPostShareUrlUpdated }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }